import {
  provideSoftAppsModule,
  provideSoftAppsRoutes,
  withSoftAppsModuleInfo,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import * as deMain from '../i18n/de.json';
import { eslConfigRoutes } from './esl-config.router';

export function provideEslConfigModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'handel-esl-config',
        icon: 'fa-regular fa-paintbrush-pencil',
        title: 'ESL Varianten',
        route: '/esl-config',
        permission: 'ESL_CONFIG',
        group: getModuleGroupByName('Elektronische Etiketten'),
      },
      withSoftAppsModuleTranslation({
        de: deMain,
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/handel/esl-config',
        description: 'Varianten der elektronischen Etiketten (ESL) konfigurieren.',
      })
    ),
    provideSoftAppsRoutes({
      app: eslConfigRoutes,
    }),
  ];
}
